import { defineStyle, defineStyleConfig } from '@chakra-ui/react';

const Button = defineStyleConfig({
  sizes: {},
  variants: {
    transparent: defineStyle({
      fontWeight: 'medium',
      background: 'transparent  !important',
      backgroundColor: 'transparent',
      border: '1px solid black',
      borderRadius: '0 !important',
      color: 'black',
      textTransform: 'uppercase',
      '&:hover': {
        textDecoration: 'underline',
      },
    }),
    underlined: defineStyle({
      background: 'transparent',
      backgroundColor: 'transparent',
      textDecoration: 'underline',
      color: 'black',
      borderRadius: 0,
      textTransform: 'lowercase',
      '&:hover': {
        textDecoration: 'none',
        background: 'transparent',
        backgroundColor: 'transparent',
      },
    }),
  },
  defaultProps: {},
});

export { Button };
